module.exports = __webpack_public_path__ + "img/dialog-bg-fail.67610f0f.png";